// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1g6K2","row":"Node_row__10R50","label":"Node_label__3I3Ah","footer":"Node_footer__2lxlH"};